class SocialMediaOverviewFilter {
  constructor(element) {
    this.element = element;
    this.tabs = document.querySelectorAll(".js-social-media-overview-tab"); // document scope since they also exist in the header.

    this.initialize();
  }

  initialize() {
    window.addEventListener("updated-params", (e) => {
      this.updateTabsHistory(e.detail.searchParams);
    });
  }

  updateTabsHistory(searchParams) {
    this.tabs.forEach((tab) => {
      const currentUrl = new URL(tab.href);
      tab.href = currentUrl.pathname + "?" + searchParams.toString();
    });
  }
}

const socialMediaOverviewFilterElement = document.querySelector("[data-js='social-media-overview-filter']");

if (socialMediaOverviewFilterElement) {
  new SocialMediaOverviewFilter(socialMediaOverviewFilterElement);
}
